import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from "@/theme/ThemeComponent";

@Component
export class SideCart extends ThemeComponent {
    @Ref() close!: HTMLDivElement;

    /**
     * Initialise.
     */
    init() {
        this.eventListeners();
    }

    /**
     * Event Listeners
     */
    eventListeners() {
        this.openCart();
        this.closeCart();
        this.closeEvent();
    }

    /**
     * Open Side Cart.
     */
    openCart() {
        document.addEventListener('cartOpen', ()=> {
            this.classList.add('is-active');
            document.body.classList.add('drawer-open');
        });
    }

    /**
     * Close Side Cart.
     */
    closeCart() {
        document.addEventListener('cartClosed', ()=> {
            this.classList.remove('is-active');
            document.body.classList.remove('drawer-open');
        });
    }

    /**
     * Cart Close click event.
     * @returns
     */
    closeEvent() {
        this.$listen(this.close, 'click', (event) => {
            event.preventDefault();
            document.dispatchEvent(new Event('cartClosed'));
        });
    }
}
